import React, { useState, Fragment } from "react";
import styles from "./Refundmenu.module.scss";
import { ReactComponent as MenuIcon } from "../../../assets/images/Icons/menu.svg";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import RefundIcon from "../../../assets/images/Icons/refund-icon.svg";
import ViewIcon from "../../../assets/images/Icons/view-details.svg";
import Menus from "../Menus/Menus";
import { ReactComponent as CloseIcon } from "../../../assets/images/Icons/close.svg";
import client from "../../../api/client";
import { useDispatch } from "react-redux";
import Modal from "react-modal";
import { customStyles } from "../../../constants/modalStyles";
import moment from "moment";
import { numberWithCommas } from "../../../utils/formatNumber";
import StatusView from "../../StatusView/StatusView";

type MenuProps = {
  data: any;
};
const RefundMenu = ({ data }: MenuProps) => {
  const dispatch = useDispatch();
  const [menuOption, setMenuOption] = useState(false);

  const [modalIsOpen, setIsOpen] = React.useState(false);
  function closeModal() {
    setIsOpen(false);
  }
  function openModal() {
    setIsOpen(true);
  }
  const handleClickAway = () => {
    setMenuOption(false);
  };
  const handleMenu = () => {
    setMenuOption(!menuOption);
  };

  return (
    <Fragment>
      <ClickAwayListener onClickAway={handleClickAway}>
        <div className={styles.menuBody}>
          <div className={styles.menuIcon} onClick={handleMenu}>
            <MenuIcon />
          </div>

          {menuOption && (
            <div className={styles.menuContent} onClick={handleClickAway}>
              <Menus
                icon={ViewIcon}
                optionName={"View details"}
                onclick={() => setIsOpen(true)}
              />
            </div>
          )}
        </div>
      </ClickAwayListener>
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        contentLabel="Example Modal"
        style={customStyles}
      >
        <div className={styles.modalBody}>
          <div className={styles.modalHeader}>
            <div className={styles.background}>
              <div className={styles.linkDetails}>Refund Details</div>
              <CloseIcon onClick={closeModal} style={{ cursor: "pointer" }} />
            </div>
          </div>
          {data && (
            <div className={styles.modalContent}>
              <div className={styles.modalDetails}>
                <div className={styles.link}>Date</div>
                <div className={styles.content}>
                  {moment(data?.dateCreated).format("MMMM Do YYYY, h:mm a")}
                </div>
              </div>
              <div className={styles.modalDetails}>
                <div className={styles.link}>Status</div>
                <div className={styles.content}>
                  <StatusView status={data?.refundStatus} green="completed || approved" />
                </div>
              </div>
              <div className={styles.modalDetails}>
                <div className={styles.link}>Order Reference</div>
                <div className={styles.content}>{data?.orderReference}</div>
              </div>
              <div className={styles.modalDetails}>
                <div className={styles.link}>Merchant Name</div>
                <div className={styles.content}>{data?.subsidiaryName}</div>
              </div>
              <div className={styles.modalDetails}>
                <div className={styles.link}>Customer</div>
                <div className={styles.content}>{data?.customerName}</div>
              </div>
              <div className={styles.modalDetails}>
                <div className={styles.link}>Customer Email</div>
                <div className={styles.content}>{data?.customerEmail}</div>
              </div>
              <div className={styles.modalDetails}>
                <div className={styles.link}>Refund Amount</div>
                <div className={styles.content}>
                  {`${data?.currency ?? "NGN"} ${numberWithCommas(
                    data?.refundAmount
                  )}`}
                </div>
              </div>
              <div className={styles.modalDetails}>
                <div className={styles.link}> Transaction Amount</div>
                <div className={styles.content}>
                  {`${data?.currency ?? "NGN"} ${numberWithCommas(
                    data?.amount
                  )}`}
                </div>
              </div>

              <div className={styles.modalDetails}>
                <div className={styles.link}>Channel</div>
                <div className={styles.content}>{data?.paymentType}</div>
              </div>
              <div className={styles.modalDetails}>
                <div className={styles.link}>Reference#</div>
                <div className={styles.content}>{data?.refundReference}</div>
              </div>
            </div>
          )}
        </div>
      </Modal>
    </Fragment>
  );
};

export default RefundMenu;
